import script from "./ShareholderDividendsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareholderDividendsTable.vue?vue&type=script&setup=true&lang=ts"

import "./ShareholderDividendsTable.vue?vue&type=style&index=0&id=439e5cf0&scoped=true&lang=postcss"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-439e5cf0"]])

export default __exports__